import { startOfToday } from 'date-fns';
import { ApplianceDetailsSteppedMultiPlanFormValue } from '../../models/appliance-details-stepped-multi-plan/appliance-details-stepped-multi-plan-form-value.type';

export const mockApplianceDetailsSteppedMultiPlanFormValue: ApplianceDetailsSteppedMultiPlanFormValue =
  {
    applianceCodeBuiltIn: false,
    brandCode: 'AEG',
    purchaseDate: startOfToday(),
    purchasePrice: 300,
  };
